import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function alreadyUsedTradePlanIdBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Trade plan ID is already being used.
      </Body3>
    </td>
  );
}
